import React, {useState} from 'react';
import './AlumnosFaltantes.css';
import api from '../../../services/api.js';
import swal from 'sweetalert';

const AlumnosFaltantesComponent = () => {
    const formato = new Intl.DateTimeFormat('en-CA', {
        timeZone: 'America/Mazatlan',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
    });
    const today = formato.format(new Date());
    const [alumnos, setAlumnos] = useState([]);
    const [date, setDate] = useState(today);
    const [nivel, setNivel] = useState("");
    const [grado, setGrado] = useState("");
    const [grupo, setGrupo] = useState(null);

    const [showMessage, setShowMessage] = useState(false);
    const [alumnosSeleccionados, setAlumnosSeleccionados] = useState([]);

    const buttonDisable = {
        cursor: "not-allowed",
        opacity: "0.5",
        pointerEvents: "none",
    }

    const buscarAlumnos = async () => {
        try {
            const response = await api.getAlumnosFaltantes({nivel, grado, date, grupo});
            setAlumnos(response.data.data);
        } catch (error) {
            swal("Error", "Intente de nuevo más tarde.", "error");
            return;
        }
    }

    const enviarMensajes = async () => {
        try {
            await api.postMessageFaltas({alumnosSeleccionados});
            setShowMessage(false);
            swal("¡Éxito!", "Los mensajes se enviaron correctamente.", "success");
        } catch (error) {
            swal("Error", "Intente de nuevo más tarde.", "error");
        }

    }

    const handleCheckboxChange = (alumno) => {
        setAlumnosSeleccionados(prevSeleccionados =>
          prevSeleccionados.includes(alumno)
            ? prevSeleccionados.filter(item => item !== alumno)
            : [...prevSeleccionados, alumno]
        );
    };

    return (
        <>
        <div className= "seccion-materias hover-seccion fade-in">
            <div className= "seccion-centro">
                <div className='container-filtros'>
                    <div className='filtros-input filtros-input-date'>
                        <label>Seleccione el día</label>
                        <input type="date" value={date} onChange={ e => (setDate(e.target.value))}></input>
                    </div>
                    <div className='filtros-input'>
                        <label>Nivel</label>
                            <select name="Nivel" onChange={e => (setNivel(e.target.value))}>
                                <option value="" defaultChecked>TODOS</option>
                                <option value="PREESCOLAR">PREESCOLAR</option>
                                <option value="PRIMARIA">PRIMARIA</option>
                                <option value="SECUNDARIA">SECUNDARIA</option>
                                <option value="BACHILLERATO">BACHILLERATO</option>
                            </select>
                    </div>
                    <div className='filtros-input'>
                        <label>Grado</label>
                        <select name="Grado" onChange={e => (setGrado(e.target.value))}>
                            <option value="" defaultChecked>TODOS</option>
                            <option value="PRIMERO">PRIMERO</option>
                            <option value="SEGUNDO">SEGUNDO</option>
                            <option value="TERCERO">TERCERO</option>
                            {nivel === "PRIMARIA" ?
                                <>
                                    <option value="4">CUARTO</option>
                                    <option value="5">QUINTO</option>
                                    <option value="6">SEXTO</option>
                                </>
                            : ''}
                        </select>
                    </div>
                    <div className='filtros-input'>
                        <label>Grupo</label>
                        <input type="text" onChange={ e => (setGrupo(e.target.value))}></input>
                    </div>
                    <button onClick={buscarAlumnos}>BUSCAR</button>
                    <button onClick={e => setShowMessage(true)} style={alumnosSeleccionados.length > 0 ? {} : buttonDisable} id='button-actualizar'>NOTIFICAR</button>
                </div>
                <div className= "seccion-tabla-asistencias">
                    <div className= "hover-elemento">
                        {/* TABLA */}
                        <div className= "contenedor-tabla-asistencias">
                            <table className= "tabla-asistencias">
                                <thead>
                                    <tr>
                                        <th></th>
                                        <th><label>FECHA</label></th>
                                        <th><label>MATRICULA</label></th>
                                        <th><label>ALUMNO</label></th>
                                        <th><label>NIVEL</label></th>
                                        <th><label>GRADO</label></th>
                                        <th><label>GRUPO</label></th>
                                        <th><label>ENTRADA</label></th>
                                        <th><label>SALIDA</label></th>
                                        <th><label>MANUAL</label></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    { alumnos && alumnos.map( (alumno, i) => { 
                                        return (
                                        <tr key={ i }>
                                            <td><input type="checkbox" style={{width:'20px', height:'30px'}} onChange={() => handleCheckboxChange(alumno)}
                                                checked={alumnosSeleccionados.includes(alumno)}/></td>
                                            <td>{ alumno.FECHA.split('T')[0] }</td>
                                            <td>{ alumno.MATRICULA }</td>
                                            <td>{ alumno.ALUMNO }</td>
                                            <td>{ alumno.NIVEL }</td>
                                            <td>{ alumno.GRADO }</td>
                                            <td>{ alumno.GRUPO }</td>
                                            <td>{ alumno.ENTRADA }</td>
                                            <td>{ alumno.SALIDA }</td>
                                            <td>{ alumno.MANUAL }</td>
                                        </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        { showMessage ? <>
            <div className='overlay'></div>
            <div className='container-message' style={{height:'200px'}}>
                <div className='titulo-message'>
                    <h3>¿Seguro de enviar el aviso?</h3>
                    <label className='button-close-buscar-alumno' onClick={e => setShowMessage(false)}> X </label>
                </div>
                <div className='button-enviar-mensaje'>
                    <button onClick={enviarMensajes}>ENVIAR</button>
                </div>
            </div>
        </> : ''}
        </>
    );
};

export default AlumnosFaltantesComponent;